import { createFormState, required, isProbablyEmail } from "redux-freeform";
import { ReduxFreeformField } from "../../types";

export type LocationsFormConfig = {
  [key: string]: ReduxFreeformField;
};

export const locationsFormConfig: LocationsFormConfig = {
  name: {
    defaultValue: "",
    validators: [required()],
  },
  location_code: {
    defaultValue: "",
    validators: [required()],
  },
  email: {
    defaultValue: "",
    validators: [isProbablyEmail()],
  },
  phone_1: {
    defaultValue: "",
    validators: [required()],
  },
  phone_2: {
    defaultValue: "",
    validators: [],
  },
  address_1: {
    defaultValue: "",
    validators: [required()],
  },
  address_2: {
    defaultValue: "",
    validators: [],
  },
  city: {
    defaultValue: "",
    validators: [required()],
  },
  state: {
    defaultValue: "",
    validators: [required()],
  },
  zipcode: {
    defaultValue: "",
    validators: [required()],
  },
  default_float: {
    defaultValue: "",
    validators: [required()],
  },
};

export const {
  reducer: locationsFormReducer,
  mapStateToProps: locationsFormMapStateToProps,
  mapDispatchToProps: locationsFormMapDispatchToProps,
} = createFormState(locationsFormConfig);
